import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID, ChangeDetectionStrategy } from '@angular/core';
import { LoadingBarService, LoadingBarModule } from '@ngx-loading-bar/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { delay, map, withLatestFrom } from 'rxjs/operators';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { TapToTopComponent } from './shared/components/tap-to-top/tap-to-top.component';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LoadingBarModule, LoaderComponent, TapToTopComponent, RouterOutlet],
})
export class AppComponent {
  // For Progressbar
  loaders: Observable<number>;

  public title = 'Halo Portals';

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private loader: LoadingBarService,
    public translate: TranslateService,
  ) {
    this.loaders = this.loader.progress$.pipe(
      delay(1000),
      withLatestFrom(this.loader.progress$),
      map((v) => v[1]),
    );
    if (isPlatformBrowser(this.platformId)) {
      translate.setFallbackLang('en');
      translate.addLangs(['en', 'de', 'es', 'fr', 'pt', 'cn', 'ae', 'ru']);
    }
  }
}
